"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatWholeNumberPart = formatWholeNumberPart;
/* eslint-disable @typescript-eslint/strict-boolean-expressions -- we do not want to break this funcionality as it is implemented on purpose like this */
/**
 * Formats the whole number part of the number.
 * @param value A value representing the whole part of the number to be formatted
 * @param groupSizes Sizes of groups
 * @param groupSeparator Group separator character
 * @returns Formatted whole number part
 */
function formatWholeNumberPart(value, groupSizes = [], groupSeparator = '') {
  // No value, group sizes or separator are given. There is nothing to solve. Returns the given value.
  if (!value || !groupSizes.length || !groupSeparator) {
    return value;
  }
  const {
    length
  } = value;
  const groupSizesSum = groupSizes.reduce((acc, item) => acc + item, 0);
  // Size of the first group. It will be used to compare the value lenght.
  const firstGroupSize = groupSizes.at(0) ?? 0;
  // Size of the last group will be used to supplement the missing group sizes.
  const lastGroupSize = groupSizes.at(-1) ?? 0;

  // At least one group size must not be zero.
  // The length of the value must be greater than first group size to have something to split.
  // Otherwise returns the given value.
  if (!groupSizesSum || length <= firstGroupSize) {
    return value;
  }
  return [
  // Fill the given group sizes, e.g. [3, 2]
  ...groupSizes,
  // ... and fill the missing group sizes with the lastGroupsize value
  // e.g. fill [2, 2] for the value = `1234567890` (value.lenght = 10)
  ...Array.from({
    length: lastGroupSize && (length - groupSizesSum) / lastGroupSize
  }, () => lastGroupSize)]
  // Iterate over group sizes and split the first acc value if possible.
  //
  // E.g. for the given value `1234567890` and group sizes [3, 2] (filled into [3, 2, 2, 2])
  //
  // The acc looks like this:
  // First iteration  ['1234567890']
  // Second iteration ['1234567', '890']
  // Third iteration  ['12345', '67', '890']
  // Fourth iteration ['123', '45', '67', '890']
  //
  // Returned value   ['1', '23', '45', '67', '890']
  .reduce((acc, size) => {
    // Skip zero size.
    if (size) {
      // Gets first acc item. In the first iteration gets given value.
      const first = acc.shift() ?? '';

      // Split the given value into two parts according to the group size.
      return [first.slice(0, -size), first.slice(-size), ...acc];
    }
    return acc;
  },
  // Given value as acc initial value.
  [value]).filter(Boolean).join(groupSeparator);
}
